import tooltips from 'messages/tooltipsPlanType.json'

function getBenefitsTooltips(): {
  moop: string
  deductible: string
  coinsurance: string
  coverage: string
  period: string
} {
  return {
    moop: tooltips['Max Out of Pocket'],
    deductible: tooltips.Deductible,
    coinsurance: tooltips.Coinsurance,
    coverage: tooltips['Total Policy Coverage'],
    period: tooltips['Coverage Duration']
  }
}

export default getBenefitsTooltips
